<template>
  <div
    class="KoioteValueWriteLabel"
    :style="valueLabelStyle"
  >
    <div
      v-if="!editingValue"
      class="custom-cursor"
    >
      <p
        class="value-container"
        @click="editingValue = true"
      >
        {{ label }} {{ value }}
      </p>
    </div>
    <KoioteNumericKeyboard
      v-if="editingValue"
      :title="title"
      :original_value="value"
      :max_value="max_value"
      :min_value="min_value"
      @submit="submit"
      @cancel="editingValue = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import KoioteNumericKeyboard from "@/components/utils/KoioteNumericKeyboard.vue";

export default {
  name: "KoioteValueLabelWrite",

  components: {
    KoioteNumericKeyboard,
  },

  props: {
    input: Object,
  },

  data() {
    return {
      editingValue: false,
    };
  },

  computed: {
    valueLabelStyle() {
      return {
        backgroundColor: this.input.customized.background_color,
        color: this.input.customized.foreground_color,
        border: "1px solid " + this.input.customized.border_color,
        width: "100%",
        height: "100%",
        position: "absolute",
        alignContent: "center",
        textAlign: "center",
        whiteSpace: "break-spaces",
        lineHeight: "normal",
      };
    },

    write_topic() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        .customized.topic_write;
    },

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized?.vartable;
    },

    label() {
      return this.input.customized?.label?.length > 0 ? `${this.input.customized.label}: ` : "";
    },

    value() {
      const retrievedValue =
        this.vartable?.find((v) => v.formatted_address == this.input.customized.address)?.value || 0;

      const applicableRetrievedValue = retrievedValue == null || isNaN(retrievedValue) ? 0 : retrievedValue;

      return typeof applicableRetrievedValue === "boolean"
        ? applicableRetrievedValue
          ? this.input.customized.true_text
          : this.input.customized.false_text
        : this.input?.customized?.datatype == "ENTERO"
        ? Math.round(applicableRetrievedValue)
        : applicableRetrievedValue > 1000
        ? Math.round(applicableRetrievedValue).toFixed(2)
        : (Math.round(applicableRetrievedValue * 100) / 100).toFixed(2);
    },

    max_value() {
      return this.input.customized.max_value;
    },

    min_value() {
      return this.input.customized.min_value;
    },

    title() {
      return this.input.customized.title;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions("nodered", ["doPublish"]),

    submit(value) {
      const number_to_write = parseFloat(value) / this.input.customized.scale;
      const rawAddress = this.vartable.find((v) => v.formatted_address == this.input.customized.address)?.address;

      if (rawAddress)
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: rawAddress,
            value: this.adaptFormat({ type: this.input.customized.datatype, value: number_to_write }),
          },
        });

      this.editingValue = false;
    },

    cancel() {
      this.editingValue = false;
    },

    adaptFormat(item) {
      return (() => {
        switch (item.type) {
          case "BIT":
            return item.value;
          case "ENTERO":
          case "REAL":
            return Number(item.value);
          default:
            return "";
        }
      })();
    },
  },
};
</script>

<style scoped>
.value-container {
  margin: 0;
  padding: 0;
}

.custom-cursor {
  cursor: pointer;
}

.KoioteValueWriteLabel {
  font-size: medium;
  font-weight: normal;
}
</style>
